import fetch from  '@/api/fetch';

// 登录
export const loginIn = data => fetch.post('/login', data);

//登出
export const loginOut = data => fetch.get('/logout');

// 获取公钥
export const getPubkey = _ => fetch.get('/login/getPubkey');

// 修改密码
export const updatePass = data => fetch.post('/updatePass', data);